import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Loader from "../../components/Loader";
import axios from 'axios';
import Swal from 'sweetalert2';

const SettingsTab = ( { isActive } ) => {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const navigate = useNavigate();
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getProfile();
    }, []);

    const goDashboard = () =>{
        navigate('/dashboard');
    } 

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        await axios.put(ENDPOINT + 'update-profile-user/' + user_id, {
            name: name,
            last_name: last_name,
            email: email,
            phone: phone,
            address: address
        }).then(response => {
            getProfile();
            const dataUser = JSON.stringify(response.data.data);
            localStorage.setItem('dataUser', dataUser);
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    }

    const getProfile = async () => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        await axios.get(ENDPOINT + 'get-user/' + user_id)
        .then(response => {
            setLoading(false);
            setName(response.data.data.name)
            setLastName(response.data.data.last_name);
            setEmail(response.data.data.email);
            setPhone(response.data.data.phone);
            setAddress(response.data.data.address);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        });
    }

    return (
        <>  
            {loading && <Loader />}      
            <div className={`tab-pane ${isActive ? 'active' : ''}`}>
                <div className="row mb-4">
                    <div className="col-md-12">
                        <div className="title-form">
                            <h6 className="font-bold">
                                <i className="fas fa-user-edit me-2"></i> 
                                Información Personal
                            </h6>
                            <p className="text-muted font-size-sm mb-0">
                                Complete la información solicitada. Los campos marcados con (<span className="text-danger">*</span>) son obligatorios.
                            </p>
                        </div>
                        <hr className="my-2" />
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                Nombres <span className="text-danger">*</span>
                            </label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">
                                    <i className="fas fa-user"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Ej: Juan Pedro"
                                    id="name"
                                    name="name"
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                    required
                                />
                            </div>
                            <small className="text-muted">Ingrese sus nombres completos</small>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="last_name" className="col-form-label col-form-label-sm">
                                Apellidos <span className="text-danger">*</span>
                            </label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">
                                    <i className="fas fa-user"></i>
                                </span>
                                <input
                                    className="form-control form-control-sm"
                                    placeholder="Ej: López García"
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    onChange={(e) => setLastName(e.target.value)}
                                    value={last_name}
                                    required
                                />
                            </div>
                            <small className="text-muted">Ingrese sus apellidos completos</small>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="email" className="col-form-label col-form-label-sm">
                                Email <span className="text-danger">*</span>
                            </label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">
                                    <i className="fas fa-envelope"></i>
                                </span>
                                <input
                                    className="form-control form-control-sm"
                                    placeholder="Ej: correo@dominio.com"
                                    type="email"
                                    id="email"
                                    name="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    required
                                />
                            </div>
                            <small className="text-muted">Ingrese un correo electrónico válido</small>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="phone" className="col-form-label col-form-label-sm">
                                Teléfono <span className="text-danger">*</span>
                            </label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">
                                    <i className="fas fa-phone"></i>
                                </span>
                                <input
                                    className="form-control form-control-sm"
                                    placeholder="Ej: 999999999"
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    onChange={(e) => setPhone(e.target.value)}
                                    value={phone}
                                    required
                                />
                            </div>
                            <small className="text-muted">Ingrese un número de teléfono válido</small>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label htmlFor="address" className="col-form-label col-form-label-sm">
                                Dirección <span className="text-danger">*</span>
                            </label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">
                                    <i className="fas fa-map-marker-alt"></i>
                                </span>
                                <input
                                    className="form-control form-control-sm"
                                    placeholder="Ej: Av. Principal 123"
                                    type="text"
                                    id="address"
                                    name="address"
                                    onChange={(e) => setAddress(e.target.value)}
                                    value={address}
                                    required
                                />
                            </div>
                            <small className="text-muted">Ingrese su dirección completa</small>
                        </div>
                    </div>
                    <div className="form-group p-0 mt-4 mx-2">
                        <div className="text-right">
                            <button type='submit' className="btn btn-success btn-sm me-2">
                                <i className="fa-regular fa-floppy-disk me-2"></i> Actualizar Datos Personales
                            </button>
                            <button onClick={goDashboard} type='button' className="btn btn-danger btn-sm">
                                <i className="fa-solid fa-ban me-1"></i> Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SettingsTab;